import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import * as jsonwebtoken from "jsonwebtoken";
import axios from "axios";
import 'axios-response-logger';

Vue.use(Vuex);

const vuexSessionStorage = new VuexPersist({
    key: "vuex",
    storage: window.sessionStorage
});

export default new Vuex.Store({
    plugins: [vuexSessionStorage.plugin],
    state: {
        jwt: undefined,
        user: undefined,
        cartId: 0,
        bioDemoSubmitted: false
    },
    mutations: {
        setJWT(state, jwt) {
            state.jwt = jwt;
        },
        decodeToken(state) {
            if (state.jwt != undefined) {
                state.user = jsonwebtoken.decode(state.jwt)
             } else {
                 state.user = { roles: [] };
             }
        },
        setCartId(state, id) {
            state.cartId = id;
        },
        setBioDemoSubmitted(state, tf) {
            state.bioDemoSubmitted = tf;
        }
    },
    actions: {
        async setJWT({ commit }, {jwt}) {
            return new Promise(async (resolve, reject) => {
                try {
                    await commit("setJWT", jwt);
                    await commit("decodeToken");
                    resolve();
                } catch(error) {
                    reject(error);
                }    
            });          
        }
    },
    getters: {
        jwt: function(state) {
            return state.jwt;
        },
        api: function(state) {
            return axios.create({
            baseURL: process.env.VUE_APP_API_BASE,
            timeout: 20000,
            withCredentials: false,
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Accept": "application/json",
                "Access-Control-Allow-Origin": process.env.Access_Control_Allow_Origin,
                "Authorization": state.jwt
              }
            });
        },
        user: function(state) {
            return state.user || { roles: [] };
        },
        cartId: function(state) {
            return state.cartId;
        },
        bioDemoSubmitted: function(state) {
            return state.bioDemoSubmitted;
        }
    }
});